var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.74 17.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#58949c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.17,0A5.1,5.1,0,0,0,0,5v7.17a5.1,5.1,0,0,0,5.18,5h7.39a5.1,5.1,0,0,0,5.17-5V5a5.1,5.1,0,0,0-5.17-5Zm8.88,2.87a.73.73,0,0,1,.74.72.74.74,0,1,1-.74-.72ZM8.87,4.3a4.38,4.38,0,0,1,4.44,4.31,4.38,4.38,0,0,1-4.44,4.3,4.37,4.37,0,0,1-4.43-4.3A4.38,4.38,0,0,1,8.87,4.3Zm0,1.44a2.92,2.92,0,0,0-3,2.87,3,3,0,0,0,5.92,0A2.92,2.92,0,0,0,8.87,5.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9f6144f304804eaad1421d68ebc75063.svg";
export { ForwardRef as ReactComponent };